import React from 'react';

import { Spacer } from '@repo/ui/components/Spacer';
import { P4, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { Divider } from '../../utilities/styles';
import usePaymentInfoAddonsSection from '../hooks/usePaymentInfoAddonsSection';

import { TableRow } from './styles';

const PlanSection: React.FC = () => {
  const sections = usePaymentInfoAddonsSection();

  return (
    <>
      <P4 color={themeStyle.varInkMedium}>Kittl Credits</P4>
      <Spacer height="4px" />
      {sections.map((section) => (
        <TableRow key={section.leftText}>
          <P3>{section.leftText}</P3>
          {section.rightText && (
            <P3 style={{ textAlign: 'right' }}>{section.rightText}</P3>
          )}
        </TableRow>
      ))}
      <Divider style={{ margin: '12px 0' }} />
    </>
  );
};

export default PlanSection;
